import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { icons, LucideAngularModule } from 'lucide-angular';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HttpinterceptorInterceptor } from './app/configuration/httpinterceptor-interceptor';
import { LoaderInterceptor } from './app/common/loader-interceptor';

bootstrapApplication(App, {
  ...appConfig,
  providers: [
    ...appConfig.providers,
    // ✅ Required for interceptors
    provideHttpClient(withInterceptorsFromDi()),

    // ✅ Your interceptor
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpinterceptorInterceptor,
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    LucideAngularModule.pick(icons).providers || []
  ]
}).catch((err) => console.error(err));
